import React from 'react';

function FormButtonGroup(props) {
    return <div className="form-button-group" {...props} />;
}

export default FormButtonGroup;
